import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41eeee58")

_pushScopeId("data-v-41eeee58")
const _hoisted_1 = { class: "shell info-container info-padding" }
const _hoisted_2 = { class: "display-flex info-title-havbutton-bottom" }
const _hoisted_3 = { class: "info-light-title" }
const _hoisted_4 = { class: "flex1 display-flex justify-content-end" }
const _hoisted_5 = { class: "info-label-title" }
const _hoisted_6 = { class: "info-label-content" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "line",
  style: {"margin-top":"22px"}
}, null, -1)
const _hoisted_8 = { class: "info-title-havbutton-bottom" }
const _hoisted_9 = { class: "info-light-title " }
const _hoisted_10 = { class: "info-item display-flex" }
const _hoisted_11 = { class: "info-label-title" }
const _hoisted_12 = {
  class: "info-label-content",
  style: {"word-break":"break-word","max-width":"400px"}
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("--")
const _hoisted_14 = /*#__PURE__*/_createVNode("div", {
  class: "line",
  style: {"margin-top":"22px"}
}, null, -1)
const _hoisted_15 = { class: "info-title-havbutton-bottom" }
const _hoisted_16 = { class: "info-light-title " }
const _hoisted_17 = { class: "info-item display-flex" }
const _hoisted_18 = { class: "info-label-title" }
const _hoisted_19 = {
  class: "info-label-content",
  style: {"word-break":"break-word","max-width":"400px"}
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("--")
const _hoisted_21 = /*#__PURE__*/_createVNode("div", {
  class: "line",
  style: {"margin-top":"22px"}
}, null, -1)
const _hoisted_22 = { class: "info-light-title" }
const _hoisted_23 = { class: "flex1 display-flex justify-content-end" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "height10px" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_26 = { class: "display-flex info-title-havbutton-bottom" }
const _hoisted_27 = { class: "info-light-title" }
const _hoisted_28 = { class: "flex1 display-flex justify-content-end" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { style: {"height":"8px"} }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_31 = { class: "display-flex info-title-havbutton-bottom" }
const _hoisted_32 = { class: "info-light-title" }
const _hoisted_33 = { class: "popover-text" }
const _hoisted_34 = { class: "flex1 display-flex justify-content-end" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { style: {"height":"8px"} }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_37 = { class: "display-flex info-title-havbutton-bottom" }
const _hoisted_38 = { class: "info-light-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_button_tip = _resolveComponent("button-tip")
  const _component_add_button = _resolveComponent("add-button")
  const _component_secondary_nav = _resolveComponent("secondary-nav")
  const _component_list = _resolveComponent("list")
  const _component_question_tip = _resolveComponent("question-tip")
  const _component_device_icon = _resolveComponent("device-icon")
  const _component_device_status = _resolveComponent("device-status")
  const _component_set_pin_card = _resolveComponent("set-pin-card")
  const _component_edit_accessible_floors = _resolveComponent("edit-accessible-floors")
  const _component_face_recognition_enrollment_dialog = _resolveComponent("face-recognition-enrollment-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("b", _hoisted_3, _toDisplayString(_ctx.$wordList.ProperAllTextInformation), 1),
        _createVNode("div", _hoisted_4, [
          (_ctx.isShowResetBtn)
            ? (_openBlock(), _createBlock(_component_cus_button, {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetPw(_ctx.id, _ctx.role))),
                class: "margin-right10px info-title-button"
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.TabelResetPwTitle), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_cus_button, {
            onClick: _ctx.goEditInfo,
            type: "blue",
            class: "info-title-button"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.TabelConfigInHtmlModify), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.info, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: ['info-item',index != _ctx.info.length - 1?'info-item-bottom':''],
          key: item
        }, [
          _createVNode("label", _hoisted_5, _toDisplayString(item.label), 1),
          _createVNode("label", _hoisted_6, [
            _createTextVNode(_toDisplayString(item.content) + " ", 1),
            (item.name == 'Name' && _ctx.type === 'community')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  (_ctx.role == '21')
                    ? (_openBlock(), _createBlock(_component_button_tip, {
                        key: 0,
                        color: "#676767"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextMemberAccount), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_button_tip, { key: 1 }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextMasterAccount), 1)
                        ]),
                        _: 1
                      }))
                ], 64))
              : _createCommentVNode("", true),
            (item.name == 'Name' && _ctx.type === 'office')
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (_ctx.role == '30')
                    ? (_openBlock(), _createBlock(_component_button_tip, {
                        key: 0,
                        color: "#676767"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.BasicUser), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_button_tip, { key: 1 }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.AdvancedUser), 1)
                        ]),
                        _: 1
                      }))
                ], 64))
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128)),
      (_ctx.type==='community')
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode("b", _hoisted_9, _toDisplayString(_ctx.$wordList.AccessFloor), 1)
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$wordList.AccessFloor), 1),
              _createVNode("p", _hoisted_12, [
                (_ctx.AccessFloor.length === 0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_13
                    ], 64))
                  : (_ctx.AccessFloor[0] === 'all')
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.AllFloors), 1)
                      ], 64))
                    : (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.AccessFloor, (item, index) => {
                        return (_openBlock(), _createBlock(_Fragment, { key: item }, [
                          _createTextVNode(_toDisplayString(item) + _toDisplayString(index !== _ctx.AccessFloor.length - 1 ? ', ' : ''), 1)
                        ], 64))
                      }), 128))
              ]),
              _createVNode("i", {
                class: "el-icon-my-modify edit-floor-icon",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowEditAccessibleFloors=true))
              })
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.type==='office')
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _hoisted_14,
            _createVNode("div", _hoisted_15, [
              _createVNode("b", _hoisted_16, _toDisplayString(_ctx.$wordList.AccessFloor), 1)
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$wordList.AccessFloor), 1),
              _createVNode("p", _hoisted_19, [
                (_ctx.floor.length === 0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_20
                    ], 64))
                  : (_ctx.floor[0] === 'all')
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.AllFloors), 1)
                      ], 64))
                    : (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.floor, (item, index) => {
                        return (_openBlock(), _createBlock(_Fragment, { key: item }, [
                          _createTextVNode(_toDisplayString(item) + _toDisplayString(index !== _ctx.floor.length - 1 ? ', ' : ''), 1)
                        ], 64))
                      }), 128))
              ]),
              _createVNode("i", {
                class: "el-icon-my-modify edit-floor-icon",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowEditAccessibleFloors=true))
              })
            ])
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_21,
      _createVNode("div", {
        class: ['display-flex', (_ctx.activeKey != 'face' || _ctx.faceData.length == 0)?'info-title-havbutton-bottom':'info-title-bottom']
      }, [
        _createVNode("b", _hoisted_22, _toDisplayString(_ctx.$wordList.ProperAllTextAccessType), 1),
        _createVNode("div", _hoisted_23, [
          (_ctx.activeKey != 'face' || _ctx.faceData.length == 0)
            ? (_openBlock(), _createBlock(_component_add_button, {
                key: 0,
                class: "info-title-button",
                onClick: _ctx.addAccess
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createVNode(_component_secondary_nav, {
        navs: _ctx.secNavs,
        active: _ctx.activeKey,
        onChoose: _ctx.changeActiveKey
      }, null, 8, ["navs", "active", "onChoose"]),
      _hoisted_24,
      _withDirectives(_createVNode(_component_list, {
        class: "max-height250px overflow-auto",
        headers: _ctx.pinHeader,
        listData: _ctx.pinData,
        update: _ctx.updateAccessType,
        showCheck: false,
        showDefaultAction: [],
        action: _ctx.pinAction,
        onEdit: _ctx.editPin
      }, {
        CreatorSlot: _withId((data) => [
          (_ctx.type==='community')
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(data.scope.Special == 0 ? _ctx.$wordList.TabelUserInHtmlRoleManage : _ctx.$wordList.ProperAllTextResident), 1)
              ], 64))
            : (_ctx.type==='office')
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(data.scope.Special == 0 ? _ctx.$wordList.TabelUserInHtmlRoleManage : (_ctx.role == '30'
                            ? _ctx.$wordList.BasicUser : _ctx.$wordList.AdvancedUser)), 1)
                ], 64))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["headers", "listData", "update", "action", "onEdit"]), [
        [_vShow, _ctx.activeKey == 'pin']
      ]),
      _withDirectives(_createVNode(_component_list, {
        class: "max-height250px overflow-auto",
        headers: _ctx.cardHeader,
        listData: _ctx.cardData,
        update: _ctx.updateAccessType,
        showCheck: false,
        showDefaultAction: [],
        action: _ctx.cardAction,
        onEdit: _ctx.editCard
      }, null, 8, ["headers", "listData", "update", "action", "onEdit"]), [
        [_vShow, _ctx.activeKey == 'card']
      ]),
      _withDirectives(_createVNode(_component_list, {
        headers: _ctx.faceHeader,
        listData: _ctx.faceData,
        update: _ctx.updateAccessType,
        showCheck: false,
        action: _ctx.faceAction,
        onEdit: _ctx.addFace,
        showDefaultAction: []
      }, {
        ImageSlot: _withId(() => [
          _createVNode("img", {
            class: "vertical-align-middle",
            src: require('@/assets/image/face-id-default.png'),
            ref: _ctx.setAllImg
          }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["headers", "listData", "update", "action", "onEdit"]), [
        [_vShow, _ctx.activeKey == 'face']
      ]),
      _createVNode("input", {
        ref: "fileEle",
        accept: ".jpg,.png,.bmp",
        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.chooseFace && _ctx.chooseFace(...args))),
        type: "file",
        class: "display-none"
      }, null, 544),
      _hoisted_25,
      _createVNode("div", _hoisted_26, [
        _createVNode("b", _hoisted_27, _toDisplayString(_ctx.$wordList.ProperAllTextAccessGroup), 1),
        _createVNode("div", _hoisted_28, [
          _createVNode(_component_cus_button, {
            class: "info-title-button",
            type: "blue",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.accessGroupEdit(_ctx.roomId, _ctx.officeData)))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.TabelConfigInHtmlModify), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_29,
      _createVNode(_component_list, {
        class: "max-height250px overflow-auto",
        headers: _ctx.accessGroupHeaders,
        listData: _ctx.accessGroupData,
        update: _ctx.updateAccessType,
        showCheck: false,
        action: false
      }, {
        RepeatSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(_ctx.repeatLabels[data.scope.SchedulerType]), 1)
        ]),
        TimeSlot: _withId((data) => [
          _createTextVNode(_toDisplayString(data.scope.SchedulerType == 0 ?
                            data.scope.BeginTime + ' ~ ' + data.scope.EndTime :
                            data.scope.StartTime + ' ~ ' + data.scope.StopTime), 1)
        ]),
        _: 1
      }, 8, ["headers", "listData", "update"]),
      (_ctx.isShowSelfAccess && _ctx.community.hasHaveAccessArea.value)
        ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            _hoisted_30,
            _createVNode("div", _hoisted_31, [
              _createVNode("b", _hoisted_32, _toDisplayString(_ctx.$wordList.ProperAllTextSelfDevicesAuthorization), 1),
              _createVNode(_component_question_tip, {
                placement: "top-start",
                class: "margin-left10px",
                "self-class": 'question-height18px'
              }, {
                default: _withId(() => [
                  _createVNode("p", _hoisted_33, _toDisplayString(_ctx.$wordList.ProperAllTextSelfDeviceTip), 1)
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_34, [
                _createVNode(_component_cus_button, {
                  class: "info-title-button",
                  type: "blue",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selfAccessEdit(_ctx.roomId, _ctx.type==='office'?_ctx.id:false)))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.TabelConfigInHtmlModify), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_35,
            _createVNode(_component_list, {
              headers: _ctx.selfAccessHeaders,
              listData: _ctx.selectAccessData,
              update: _ctx.updateAccessType,
              showCheck: false,
              action: false
            }, {
              RepeatSlot: _withId((data) => [
                _createTextVNode(_toDisplayString(_ctx.repeatLabels[data.scope.SchedulerType]), 1)
              ]),
              TimeSlot: _withId((data) => [
                _createTextVNode(_toDisplayString(data.scope.SchedulerType == 0 ?
                                data.scope.BeginTime + ' ~ ' + data.scope.EndTime :
                                data.scope.StartTime + ' ~ ' + data.scope.StopTime), 1)
              ]),
              _: 1
            }, 8, ["headers", "listData", "update"])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.type==='office')
        ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
            _hoisted_36,
            _createVNode("div", _hoisted_37, [
              _createVNode("b", _hoisted_38, _toDisplayString(_ctx.$wordList.OrderDevice), 1)
            ]),
            _createVNode(_component_list, {
              "show-check": false,
              headers: _ctx.deviceHeader,
              "list-data": _ctx.devices,
              showDefaultAction: [],
              action: false,
              update: _ctx.updateDevice,
              "delete-url": ""
            }, {
              TypeSlot: _withId((data) => [
                _createVNode(_component_device_icon, {
                  class: "vertical-align-middle",
                  type: Number(data.scope.Type)
                }, null, 8, ["type"])
              ]),
              StatusSlot: _withId((data) => [
                _createVNode(_component_device_status, {
                  class: "vertical-align-middle",
                  type: Number(data.scope.Status)
                }, null, 8, ["type"])
              ]),
              _: 1
            }, 8, ["headers", "list-data", "update"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isShow)
      ? (_openBlock(), _createBlock(_component_set_pin_card, {
          key: 0,
          id: _ctx.setPinCardId,
          code: _ctx.code,
          type: _ctx.setPinCardType,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShow = false)),
          onSuccess: _ctx.getAccessInfo
        }, null, 8, ["id", "code", "type", "onSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.isShowEditAccessibleFloors)
      ? (_openBlock(), _createBlock(_component_edit_accessible_floors, {
          key: 1,
          id: _ctx.id,
          initFloors: (_ctx.community.isNew.value&&_ctx.type==='community')?_ctx.AccessFloor:_ctx.floor,
          floorKey: (_ctx.community.isNew.value&&_ctx.type==='community')?'AccessFloor':'Floor',
          apiKey: (_ctx.community.isNew.value&&_ctx.type==='community')?'editComAccessFloor':'editAccessFloor',
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowEditAccessibleFloors=false)),
          onSuccess: _cache[9] || (_cache[9] = ($event: any) => (_ctx.initInfo(_ctx.id, _ctx.type)))
        }, null, 8, ["id", "initFloors", "floorKey", "apiKey"]))
      : _createCommentVNode("", true),
    (_ctx.isShowFaceRecognitionEnrollmentDialog)
      ? (_openBlock(), _createBlock(_component_face_recognition_enrollment_dialog, {
          key: 2,
          onClose: _ctx.cancelFaceRecognitionEnrollment,
          onAllow: _ctx.allowFaceRecognitionEnrollment
        }, null, 8, ["onClose", "onAllow"]))
      : _createCommentVNode("", true)
  ]))
})